import styled, { css } from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import HtmlToText from 'html-to-text';
import _ from 'lodash';

import DefaultAvatarIcon from 'components/lib/icons/default_avatar.jsx';

const getInitials = name => {
  const splitName = HtmlToText.fromString(name)
    .trim()
    .split(' ');
  const firstInitial = _.head(splitName)[0];
  const secondInitial = splitName.length > 1 ? _.last(splitName)[0] : '';
  return `${firstInitial}${secondInitial}`.toUpperCase();
};

const Avatar = ({ image, name = '' }) => {
  if (!image && name) {
    return <StyledAvatar>{getInitials(name)}</StyledAvatar>;
  }
  if (image) {
    return <StyledAvatar image={image} />;
  }
  return <StyledDefaultAvatarIcon />;
};

Avatar.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
};

const withAvatarSize = size => {
  switch (size) {
    case 'inbox':
      return AvatarInbox;
    case 'xlarge':
      return AvatarXLarge;
    case 'large':
      return AvatarLarge;
    default:
      return AvatarDefault;
  }
};

const AvatarDefault = css`
  width: 34px;
  height: 34px;
`;

const AvatarLarge = css`
  height: 55px;
  width: 55px;
`;

const AvatarXLarge = css`
  height: 250px;
  width: 250px;
`;

const AvatarInbox = css`
  height: 44px;
  width: 44px;
`;

const StyledDefaultAvatarIcon = styled(DefaultAvatarIcon)`
  ${p => withAvatarSize(p.size)};
`;

const StyledAvatar = styled.div`
  background-image: ${p => (p.image ? `url(${p.image})` : '')};
  background-color: ${p => p.theme.colors.blue700};
  background-position: center;
  background-size: cover;
  border-radius: 999px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  display: flex;
  color: ${p => p.theme.colors.white};
  ${p => withAvatarSize(p.size)};
`;

export default Avatar;
